import { useInstantSearch } from 'react-instantsearch'

import { useTranslate } from 'hooks'

import css from './hit-result-counts.module.scss'

const HitResultCounts = () => {
  const { t } = useTranslate('strapi-search-[...term]')
  const { results, status } = useInstantSearch()

  return (
    <div className={css.container}>
      <span data-test-id="hits-count" className={css.hitCounts}>{`${status === 'idle' ? results.nbHits : ' '}`}</span>
      {t('PageSearch.PageSearch_Results')}
    </div>
  )
}

export default HitResultCounts
